import {Component, computed, Input, OnInit, Signal} from '@angular/core';

import {BreadCrumb, LogoAreaComponent} from '../logo-area/logo-area.component';
import {Organization} from '../../types-repository';
import {HeadlineSectionComponent} from '../headline-section/headline-section.component';
import {AirlineSelectComponent} from '../airline-select/airline-select.component';
import {ContextService} from '../../services/context.service';

@Component({
  selector: 'app-previews-select-airline',
  templateUrl: './previews.component.html',
  styleUrls: ['./previews.component.scss'],
  imports: [
    LogoAreaComponent, HeadlineSectionComponent, AirlineSelectComponent
  ]
})
export class PreviewsComponent implements OnInit {
  organization: Signal<Organization>;


  constructor(contextService: ContextService) {
    this.organization = contextService.organization;
  }

  ngOnInit(): void {
  }
}
